import useTranslation from 'next-translate/useTranslation';
import useKeyboardInteractions from 'src/hooks/useKeyboardInteractions';
import useSubtitle from 'src/hooks/useSubtitle';
import { NAVIGATION_KEYS } from 'src/interfaces/enums';
import SettingOption from 'src/themes/cosmos/components/SettingOption';
import { ChevronRightIcon } from 'src/themes/cosmos/icons';
import useMenuRoute from 'src/themes/shared/containers/MenuRouteContainer/hooks/useMenuRoute';
import Button from 'src/themes/cosmos/components/Button';
import SettingOptionLabel from 'src/themes/cosmos/components/SettingOptionLabel';
import { useMemo } from 'react';
import { MENU_ROUTES } from '../../routes';
import styles from './styles.module.scss';

const SubtitleStyleControlContainer = () => {
  const { t } = useTranslation('common');

  const { push } = useMenuRoute();
  const { subtitleStyle, setDefaultSubtitleStyle } = useSubtitle();
  const { registerItem } = useKeyboardInteractions();

  const subtitleStyleOptions = useMemo(
    () => [
      {
        label: t('subtitles.styles.options.color'),
        value: t(`subtitles.styles.colors.${subtitleStyle.color}`, {}, { fallback: '' }),
        menuRoute: MENU_ROUTES.STYLES_COLOR,
      },
      {
        label: t('subtitles.styles.options.background'),
        value: t(`subtitles.styles.colors.${subtitleStyle.background}`, {}, { fallback: '' }),
        menuRoute: MENU_ROUTES.STYLES_BACKGROUND_COLOR,
      },
      {
        label: t('subtitles.styles.options.stroke'),
        value: t(`subtitles.styles.stroke.${subtitleStyle.stroke}`, {}, { fallback: '' }),
        menuRoute: MENU_ROUTES.STYLES_BORDER,
      },
      {
        label: t('subtitles.styles.options.opacity'),
        value: subtitleStyle.opacity ? `${subtitleStyle.opacity}%` : '',
        menuRoute: MENU_ROUTES.STYLES_BACKGROUND_OPACITY,
      },
      {
        label: t('subtitles.styles.options.font_size'),
        value: subtitleStyle.size ? `${subtitleStyle.size}%` : '',
        menuRoute: MENU_ROUTES.STYLES_FONT_SIZE,
      },
    ],
    [subtitleStyle.background, subtitleStyle.color, subtitleStyle.opacity, subtitleStyle.size, subtitleStyle.stroke, t],
  );

  return (
    <>
      {subtitleStyleOptions.map((option, index) => (
        <SettingOption
          key={option.label}
          {...registerItem({
            index,
            keyActions: {
              [NAVIGATION_KEYS.ARROW_RIGHT]: () => push(option.menuRoute),
            },
          })}
          aria-haspopup
          data-testid={`subtitle-style-option-${option.label}`}
          rightIcon={<ChevronRightIcon />}
          onClick={() => push(option.menuRoute)}
        >
          <SettingOptionLabel label={option.label} value={option.value} />
        </SettingOption>
      ))}
      <div className={styles.wrapperDefaultButton}>
        <Button onClick={setDefaultSubtitleStyle} fullWidth>
          {t('settings.subtitle.default_style')}
        </Button>
      </div>
    </>
  );
};

export default SubtitleStyleControlContainer;
